import { createContext } from "react";

const formContext = createContext()

export default formContext;